import api from "@/services/api";

const state = {
  terms: null,
};

const getters = {
  terms: (state) => state.terms,
};

const mutations = {
  SET_TERMS(state, payload) {
    state.terms = payload;
  },
};

const actions = {
  async getTerms({ commit }) {
    try {
      const res = await api.get("/terms");
      commit("SET_TERMS", res.data);
    } catch (error) {
      console.error("Error fetching terms:", error.message);
      throw error;
    }
  },

  async saveTerms({ dispatch }, payload) {
    try {
      await api.put("/terms", payload);
      await dispatch("getTerms");
    } catch (error) {
      console.error("Error saving terms:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};